export const getSelectClassNames = () => {
  return {
    optionsContainer:
      'py-xs bg-default border border-status-selected z-floatingDropdown overflow-y-auto max-h-52 focus-visible:outline-none',
    optionContainerTop: 'border-b-0 rounded-t shadow-reversed',
    optionContainerBottom: 'border-t-0 rounded-b shadow',
    option:
      'flex gap-xs px-sm py-3xs text-sm cursor-pointer transition-colors focus-visible:outline-none',
  };
};
